// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__OOVRC","list":"BalanceDue_list__3tvpC","listRow":"BalanceDue_listRow__2UIp2","total":"BalanceDue_total__18vsA"};